<template>
    <div style="padding: 16px;">
        <Breadcrumb style="margin-bottom: 14px">
            <BreadcrumbItem>{{ $t('zhuang-tai-ji-guan-li') }}</BreadcrumbItem>
        </Breadcrumb>
        <div class="page-header-container">
            <Form ref="formInline" :model="searchKey" inline label-position="right"
                  style="padding-right: 300px">
                <FormItem>
                    <Select v-model="searchType" style="width:100px" @on-change="handleChangeSearchType">
                        <Option value="status" :label="$t('zhuang-tai')">
                            <span>{{ $t('zhuang-tai') }}</span>
                        </Option>
                        <Option value="instanceId" :label="$t('ren-wu-id')">
                            <span>{{ $t('ren-wu-id') }}</span>
                        </Option>
                    </Select>
                </FormItem>
                <FormItem v-if="searchType==='instanceId'">
                    <Input v-model="searchKey.dataJobName" style="width: 280px"/>
                </FormItem>
                <FormItem v-if="searchType==='status'">
                    <Select v-model="searchKey.dataTaskState" style="width: 280px">
                        <Option value="all">{{ $t('quan-bu') }}</Option>
                        <Option v-for="(state) of dataStates" :value="state" :key="state">{{`${TaskStateMapping.taskState[state]}（${state}）`}}</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <pd-button type="primary" @click="getFsmList">{{ $t('cha-xun') }}</pd-button>
                </FormItem>
            </Form>
            <pd-button type="default" style="position: absolute;right: 20px;top: 12px" @click="handleRefresh"
                    :loading="refreshLoading">
                {{ $t('shua-xin') }}
            </pd-button>
        </div>
        <Table style="margin-top: 20px" size="small" border :columns="stateColumn" :data="showData">
            <template slot-scope="{ row }" slot="link">
                <a @click="handleDetail(row.id)" style="color: #0BB9F8;width:100%;display: block">{{row.id}}</a>
            </template>
            <template slot-scope="{ row }" slot="action">
                <a style="margin-right: 5px" @click="handleDetail(row)">{{ $t('xiang-qing') }}
                </a>
              <a v-if="myAuth.includes('CC_FSM_MANAGE') && row.active" style="margin-right: 5px" @click="handleShowInactiveFsmModal(row)">{{ $t('shi-huo') }}
              </a>
                <a v-if="myAuth.includes('CC_FSM_MANAGE') && !row.active" style="margin-right: 5px" @click="handleActive(row)">{{ $t('ji-huo') }}
                </a>
            </template>
        </Table>
        <div class="page-footer-container">
            <div class="page-footer-paging">
                <Page :total="stateData.length" show-total
                      @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange"/>
            </div>
        </div>
      <Modal
        v-model="showInactiveFsmModal"
        :title="$t('shi-huo-zhuang-tai-ji-que-ren')"
        footer-hide
      >
        <div>
          <p>{{ $t('que-ren-yao-shi-huo-ming-wei-selectedrowdatajobdesc-selectedrowdatajobname-de-zhuang-tai-ji', [selectedRow.dataJobName, selectedRow.dataJobDesc]) }}</p>
          <div slot="footer" class="modal-footer" style="margin-top: 20px">
            <pd-button type="primary" @click="handleInActive">{{ $t('que-ding') }}</pd-button>
            <pd-button @click="hideInactiveFsmModal">{{ $t('qu-xiao') }}</pd-button>
          </div>
        </div>
      </Modal>
    </div>
</template>
<script>
import { listFSM, reactiveFSM, inactiveFSM } from '@/services/cc/api/fsm';
import { listDataTaskStates } from '@/services/cc/api/constant';
import { mapState } from 'vuex';
import fecha from 'fecha';
import _ from 'lodash';
import TaskStateMapping from '../util';

export default {
  mounted() {
    this.getFsmList();
    this.listDataTaskStates();
  },
  data() {
    return {
      showInactiveFsmModal: false,
      selectedRow: {},
      searchType: 'status',
      TaskStateMapping,
      refreshLoading: false,
      searchKey: {
        dataTaskState: 'all',
        dataJobName: ''
      },
      page: 1,
      size: 10,
      dataStates: [],
      stateColumn: [
        {
          title: this.$t('zhuang-tai-ji-id'),
          width: 100,
          key: 'id'
        },
        {
          title: this.$t('ren-wu-id'),
          key: 'dataJobName',
          width: 200,
          render: (h, params) => h('a', {
            on: {
              click: () => {
                this.$router.push({ path: `/data/job/${params.row.dataJobId}` });
              }
            }
          }, params.row.dataJobName)
        },
        {
          title: this.$t('miao-shu'),
          minWidth: 200,
          key: 'dataJobDesc'
        },
        {
          title: this.$t('chuang-jian-shi-jian'),
          key: 'gmtCreate',
          width: 190,
          sortable: true,
          render: (h, params) => h('div', {}, fecha.format(new Date(params.row.gmtCreate), 'YYYY-MM-DD HH:mm:ss'))
        },
        {
          title: this.$t('dang-qian-zhuang-tai'),
          key: 'dataTaskState',
          width: 220,
          render: (h, params) => h('div', {}, `${TaskStateMapping.taskState[params.row.dataTaskState]}（${params.row.dataTaskState}）`)
        },
        {
          title: this.$t('xian-qian-zhuang-tai'),
          key: 'prevTaskState',
          width: 200,
          render: (h, params) => h('div', {}, `${TaskStateMapping.taskState[params.row.prevTaskState]}（${params.row.prevTaskState}）`)
        },
        {
          title: this.$t('huo-yue-zhuang-tai'),
          key: 'active',
          width: 120,
          render: (h, params) => {
            if (!params.row.active && params.row.dataTaskState === 'COMPLETE') {
              return h('div', {
                style: {
                  marginLeft: '40px'
                }
              }, '-');
            }
            return h('div', {
              style: {
                background: params.row.active ? 'rgb(25, 190, 107)' : 'rgb(237, 64, 20)',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                marginLeft: '40px'
              }
            });
          }
        },
        {
          title: this.$t('shi-fou-you-yi-chang'),
          key: 'exceptionStr',
          width: 150,
          render: (h, params) => h('div', {
            style: {
              color: params.row.exceptionStr ? 'rgb(237, 64, 20)' : ''
            }
          }, params.row.exceptionStr ? this.$t('you') : this.$t('wu-0'))
        },
        {
          title: this.$t('cao-zuo'),
          key: '',
          slot: 'action',
          fixed: 'right',
          width: 150
        }
      ],
      stateData: [],
      showData: []
    };
  },
  computed: {
    ...mapState(['myAuth'])
  },
  methods: {
    hideInactiveFsmModal() {
      this.showInactiveFsmModal = false;
    },
    handleShowInactiveFsmModal(row) {
      this.showInactiveFsmModal = true;
      this.selectedRow = row;
    },
    handleRefresh() {
      this.getFsmList();
    },
    handleDetail(row) {
      this.$router.push({ path: `/ccsystem/fsm/${row.id}/${row.dataJobId}` });
    },
    handleInActive() {
      inactiveFSM({
        fsmId: this.selectedRow.id
      }).then((res) => {
        if (res.data.code === '1') {
          this.$Message.success(this.$t('shi-huo-cheng-gong'));
          this.showInactiveFsmModal = false;
          this.getFsmList();
        }
      });
    },
    handleActive(row) {
      reactiveFSM({
        fsmId: row.id,
        dataJobId: row.dataJobId
      }).then((res) => {
        if (res.data.code === '1') {
          this.$Message.success(this.$t('ji-huo-cheng-gong'));
          this.getFsmList();
        }
      });
    },
    getFsmList() {
      this.refreshLoading = true;
      const searchData = _.cloneDeep(this.searchKey);

      if (searchData.dataTaskState === 'all') {
        searchData.dataTaskState = '';
      }
      listFSM(searchData).then((res) => {
        if (res.data.code === '1') {
          this.stateData = res.data.data;
          this.showData = this.stateData.slice((this.page - 1) * this.size, this.page * this.size);
        }
        this.refreshLoading = false;
      }).catch(() => {
        this.refreshLoading = false;
      });
    },
    listDataTaskStates() {
      listDataTaskStates().then((res) => {
        if (res.data.code === '1') {
          this.dataStates = res.data.data;
        }
      });
    },
    handlePageChange(page) {
      this.page = page;
      this.showData = this.stateData.slice((this.page - 1) * this.size, this.page * this.size);
    },
    handlePageSizeChange(size) {
      this.size = size;
      this.showData = this.stateData.slice((this.page - 1) * this.size, this.page * this.size);
    },
    handleChangeSearchType() {
      this.searchKey = {
        dataTaskState: 'all',
        dataJobName: ''
      };
    }
  }
};
</script>
<style lang="less">
    .state-machine-wrapper {
        background: #ffffff;
        margin-top: 16px;
        padding: 24px;
        border: 1px solid #ccc;
    }
</style>
